export const SET_TEACHERS = 'set_teachers'
export const RESET_TEACHERS = 'reset_teachers'
export const CURRENT_TEACHER = 'current_teacher'
